/**
 * P-33c (D-188) — the company's own customer page (`/organizations/<OTE>`) is
 * never opened: not even from a direct link. Pure: used by OrganizationPage
 * and the link helpers.
 */
export function isCompanyOrganization(
  org: { id?: string; is_internal?: boolean | null } | null | undefined,
  internalOrgId: string | null | undefined,
  routeId?: string | null
): boolean {
  if (org?.is_internal === true) return true;
  const id = routeId ?? org?.id;
  return !!internalOrgId && !!id && id === internalOrgId;
}

/**
 * Where a link to an organization goes: the customer page, or `null` for the
 * company (the caller shows "OTE, עבודה פנימית" as plain text).
 */
export function organizationHref(orgId: string, internalOrgId: string | null | undefined): string | null {
  return isCompanyOrganization(null, internalOrgId, orgId) ? null : `/organizations/${orgId}`;
}

/** Pure: the company's name becomes the internal-work label; any other name stays. */
export function customerDisplayName(
  orgId: string | null | undefined,
  name: string | null | undefined,
  internalOrgId: string | null | undefined,
  internalLabel: string
): string {
  if (orgId && !organizationHref(orgId, internalOrgId)) return internalLabel;
  return name ?? '';
}
